import React, { useState, useEffect, useRef, useCallback } from "react";
import SpeAccDataService from "../services/SpeAccService";
import { Link, useParams, useNavigate } from 'react-router-dom';
import TransactionTable from "../../components/TransactionTable";

const SpeAccList = (props) => {
  const [speAcc, setSpeAcc] = useState([]);
  const speAccRef = useRef();
  speAccRef.current = speAcc;

  let { owner } = useParams();

  const retrieveSpeAcc = useCallback((ownerParam) => {
    const target = ownerParam ?? owner;
    SpeAccDataService.getAll(target)
      .then((response) => {
        const payload = response?.data ?? response;
        const rows = payload?.data ?? payload?.speAcc ?? payload;
        setSpeAcc(Array.isArray(rows) ? rows : (rows ? [rows] : []));
      })
      .catch((e) => {
        console.error("SpeAccList.retrieveSpeAcc error:", e?.response?.status, e?.response?.data || e?.message || e);
        setSpeAcc([]);
      });
  }, [owner]);

  const navigate = useNavigate();
  useEffect(() => {
    retrieveSpeAcc();
  }, [retrieveSpeAcc]);

  const deleteSpeAcc = useCallback((rowIndex) => {
    const id = speAccRef.current[rowIndex].id || speAccRef.current[rowIndex]._id;
    SpeAccDataService.remove(id)
      .then(() => {
        if (props?.history?.push) props.history.push("dashboard/speacc");
        const newRows = [...speAccRef.current];
        newRows.splice(rowIndex, 1);
        setSpeAcc(newRows);
      })
      .catch((e) => {
        console.error("deleteSpeAcc error:", e?.response?.status || e?.message || e);
      });
  }, [props.history]);

  const handleView = useCallback((row) => {
    const id = row.id || row._id;
    if (id && props?.history?.push) props.history.push(`/dashboard/speacc/${id}`);
  }, [props.history]);

  const handleEdit = useCallback((row) => {
    const id = row.id || row._id;
    if (id && props?.history?.push) props.history.push(`/dashboard/speacc/edit/${id}`);
  }, [props.history]);

  const handleDeleteRow = useCallback((row) => {
    const idx = speAccRef.current.findIndex(item => (item.id || item._id) === (row.id || row._id));
    if (idx >= 0) deleteSpeAcc(idx);
  }, [deleteSpeAcc]);

  return (
    <div className="list row">
      <div className="col-md-12 list">
        <TransactionTable
          transactions={speAcc}
          onView={handleView}
          onEdit={handleEdit}
          onDelete={handleDeleteRow}
          initialPageSize={10}
          showBack={true}
          onBack={() => navigate(-1)}
        />
      </div>

      <div className="col-md-8">
        <Link to={`/dashboard/speacc/add/${owner || ""}`}>
           <button className="btn btn-sm btn-danger">Add Special Account Transaction</button>
        </Link>
      </div>
    </div>
  );
};

export default SpeAccList;
